export const COURSE_STATUS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
};
